import { render, staticRenderFns } from "./PriorityType.vue?vue&type=template&id=4610e832"
import script from "./PriorityType.vue?vue&type=script&lang=js"
export * from "./PriorityType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports